module.exports = __webpack_public_path__ + "img/center_bg1.f0c7145a.png";